// Новая версия сайта, пока вкладка открыта: сервер называет версию интерфейса в каждом ответе (X-Pravosvod-Version),
// а вкладка помнит ту, с которой открылась (boot.version, её передаёт boot.ts). Разные — над разделом плашка
// «Обновить страницу»: старая вкладка не показывает того, что уже есть на сайте (краткий вывод, «Текст статьи»).
import { Store } from "./reactive";

export const VERSION_HEADER = "X-Pravosvod-Version";
export const newVersionStore = new Store(false);
let loaded = "";

export function setLoadedVersion(version: string) {
  loaded = version;
}

export function isNewVersion(served: string | null, opened: string): boolean {
  return Boolean(served && opened && served !== opened);
}

export function noteVersion(served: string | null) {
  if (isNewVersion(served, loaded) && !newVersionStore.get()) newVersionStore.set(true);
}
